"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DEGREE = 180 / Math.PI;
var toDegree = function (radian) {
    return DEGREE * radian;
};
exports.default = toDegree;
//# sourceMappingURL=to-degree.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/to-degree.js
// module id = 1153
// module chunks = 37